module.exports = __webpack_public_path__ + "static/media/logo.b4cb3fb2.png";